<template>
    <div>
        <h3 class="title"> Page introuvable !</h3>
        <figure class="image">
            <img src="../assets/notfound.svg" width="360" height="180"></figure>
    </div>
</template>
<script>
export default {
	data: function() {
        return {
            maintitle: 'Page introuvable',
        }
    },
    name: 'NotFound',
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.image {
    max-width: 360px;
}
</style>